import { number, string } from 'prop-types';
import React from 'react';

const IconCheckboxEmpty = ({
  size = 16,
  fill = 'white',
  stroke = '#94A2B7',
}) => {
  return (
    <svg
      className="icon-checkbox-unchecked"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
    >
      <rect
        x="0.5"
        y="0.5"
        width="15"
        height="15"
        rx="1.5"
        fill={fill}
        stroke={stroke}
      />
    </svg>
  );
};

IconCheckboxEmpty.propTypes = {
  size: number,
  fill: string,
  stroke: string,
};

export default IconCheckboxEmpty;
